export default __webpack_public_path__ + "media/src/assets/images/PendingIcon-9aed52e9314bba763ec26d99f10849df.svg";